"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomValidator = void 0;
const validator_1 = require("./validator");
class CustomValidator extends validator_1.CommonValidator {
    merge(props) {
        return new CustomValidator({ ...this.props, ...props });
    }
    rule(rule) {
        return this.merge({ rule });
    }
    details(details) {
        return this.merge({ details });
    }
    getPropsToLog() {
        const { rule: _, details, ...props } = super.getPropsToLog();
        return { ...props, ...(details || null) };
    }
    validateValue = async ({ rootCtx, ctx, options }) => {
        return (0, validator_1.runValidators)({
            rootCtx,
            ctx,
            options,
            validators: [this.validateRule]
        });
    };
    validateRule = async ({ ctx, next }) => {
        const { rule, details } = this.props;
        if (rule === undefined || rule(ctx.value)) {
            return next();
        }
        ctx.addError(details || {});
    };
}
exports.CustomValidator = CustomValidator;
